(function ($) {
	if ($(window).width() < 768) {
		$('.mobile-ani-disable').removeAttr('data-aos');
	}

	AOS.init();

	function handleServiceHeaderClick() {
		console.log('clicked');
		if ($(window).width() < 600) {
			if ($(this).hasClass('active')) {
				$(this).removeClass('active').next().slideUp(50);
			} else {
				$('.service-header').removeClass('active').next().slideUp(50);
				$(this).addClass('active').next().slideDown(50);
			}
		}
	}

	// Initial setup
	if ($(window).width() < 600) {
		$('.service-content').hide();
		$('.service-header').on('click', handleServiceHeaderClick);
	}

	$(window).on('resize', function(){
		if ($(window).width() > 600) {
			$('.service-header').off('click');  // Remove click event
			$('.service-content').show();
		} else {
			$('.service-content').hide();

			// Rebind click event when going back under 600px
			$('.service-header').off('click').on('click', handleServiceHeaderClick);
		}
	});



$(window).on('load resize orientationchange', function(event) {
	if($(window).width() < 992) {
        $(".c-cat-menu").addClass('cat-menu-mobile');
        if($("#c-filter-icon").hasClass("active")) {
        	$(".c-cat-menu").addClass('cat-menu-active').show();
        } else {
	        $(".c-cat-menu").removeClass('cat-menu-active').hide();
	    }
    } else {
        $(".c-cat-menu").removeClass('cat-menu-mobile');
    	$(".c-cat-menu").show().removeClass('cat-menu-active').css('display', 'inline-flex');
    }
});

$(".c-filter-icon").click(function() {
	if($(window).width() < 992) {
		if($("#c-filter-icon").hasClass("active")) {
        	$(".c-cat-menu").removeClass('cat-menu-active').slideUp();
        	$("#c-filter-icon").removeClass('active');
		} else {
        	$(".c-cat-menu").addClass('cat-menu-active').slideDown();
        	$("#c-filter-icon").addClass('active');
		}
    } else {
		$(".c-cat-menu").removeClass('cat-menu-active').css('display', 'inline-flex');
    	$("#c-filter-icon").removeClass('active');
    }
});


  // Accordions
    $(function() {
        $('.accordion-answer').hide();
        //$('.accordion-question:first').addClass('active').next().slideDown('300');
        $('.accordion-question').click(function(){

            if($(this).next().is(':hidden')) {
                $('.accordion-question').removeClass('active').next().slideUp('50');
                $(this).toggleClass('active').next().slideDown('50');
            } else if($(this).next().is(':visible')) {
                $(this).toggleClass('active').next().slideUp('50');
            }
        });
    });








$(".c-wellness-slider").slick({
	infinite: true,
	slidesToShow: 1,
	autoplay: true,
	autoplaySpeed: 3000,
	swipeToSlide: true,
	arrows: true,
	prevArrow: $(".c-wellness-slider--prev"),
	nextArrow: $(".c-wellness-slider--next")
});

$(".c-project-slider").slick({
	infinite: true,
	slidesToShow: 2,
	centerMode: true,
	swipeToSlide: true,
	arrows: true,
	prevArrow: $(".c-project-slider--prev"),
	nextArrow: $(".c-project-slider--next"),
	  responsive: [
    {
      breakpoint: 901,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});

})(jQuery);
